import React from "react";

const CasePhotos = ( {data} ) => {
    const photos = [...data.photo_card,...data.photo_card];

    return(
        <div className="flex flex-col gap-5">
            <span className="font-medium leading-tight md:text-[40px] text-[36px]" 
                    style={{color: data.title_color}}
                >
                {data.title}
            </span>
            <div className="flex justify-center">
                <div className="flex white-around w-[80%] overflow-hidden h-fit">
                    <div className="flex md:gap-3 gap-2 px-2 py-5 animate-loop-scroll  flex-shrink-0">
                        {
                            photos.map((photo_card,index) => (
                                <>
                                    <div key={index} className="flex items-center justify-center shadow-lg
                                            md:rounded-2xl rounded-xl px-10 py-8 md:h-[360px] h-[240px] aspect-[0.667]" 
                                            style={{backgroundColor:photo_card.bg_color}}
                                        >
                                        <img src={photo_card.image} alt=""/>
                                    </div>
                                        
                                </>
                            ))
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CasePhotos;